/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';

/**
 * 
 * @export
 * @interface CopyLead201Response
 */
export interface CopyLead201Response {
    /**
     * 
     */
    data?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead;
}

/**
 * Check if a given object implements the CopyLead201Response interface.
 */
export function instanceOfCopyLead201Response(value: object): value is CopyLead201Response {
    return true;
}

export function CopyLead201ResponseFromJSON(json: any): CopyLead201Response {
    return CopyLead201ResponseFromJSONTyped(json, false);
}

export function CopyLead201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyLead201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON(json['data']),
    };
}

export function CopyLead201ResponseToJSON(json: any): CopyLead201Response {
    return CopyLead201ResponseToJSONTyped(json, false);
}

export function CopyLead201ResponseToJSONTyped(value?: CopyLead201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON(value['data']),
    };
}

